<template>
  <Card>
    <div class="cardTitle">{{ $t(contactPersonTitle) }}</div>
    <v-form ref="contactForm">
      <Input
        label="ФИО"
        placeholder="Введите ФИО"
        v-model="localContact.userFullName"
        :rules="[].concat(validation.required(), rules.text(3, 100))"
        :variant="editing ? 'solo' : 'underlined'"
        :readonly="!editing"
        :required="editing"
      />
      <Input
        label="Email"
        placeholder="Введите E-mail"
        v-model="localContact.userEmail"
        :rules="[].concat(validation.required(), rules.text(_, 255), validation.email())"
        :variant="editing ? 'solo' : 'underlined'"
        :readonly="!editing"
        :required="editing"
      />
      <Input
        v-if="usePhoneMask"
        label="Телефон"
        placeholder="Введите номер телефона"
        v-model="localContact.userPhone"
        :rules="[].concat(validation.required(), validation.phone())"
        :variant="editing ? 'solo' : 'underlined'"
        :readonly="!editing"
        :required="editing"
      />
      <Input
        v-else
        label="Телефон"
        placeholder="Введите номер телефона"
        v-model="localContact.userPhone"
        :rules="[].concat(validation.required(), validation.text(255))"
        :variant="editing ? 'solo' : 'underlined'"
        :readonly="!editing"
        :required="editing"
      />
      <v-card-actions class="justify-end pa-0" v-if="!view">
        <v-btn
          v-if="editing"
          color="primary"
          density="comfortable"
          variant="outlined"
          @click="cancel()"
        >{{ $t('Отмена') }}</v-btn>
        <v-btn
          v-if="!editing"
          color="primary"
          density="comfortable"
          variant="elevated"
          @click="editing = true"
        >{{ $t('Редактировать') }}</v-btn>
        <v-btn
          v-if="editing"
          color="primary"
          density="comfortable"
          variant="elevated"
          @click="save()"
        >{{ $t('Cохранить') }}</v-btn>
      </v-card-actions>
    </v-form>
  </Card>
</template>

<script>
import { toast } from '@/lib/toast';
import Config from "@/config";
import validation from '@/components/validation';
import Card from "@intec/vue-components/form/Card.vue";
import Input from "@intec/vue-components/form/Input.vue";

export default {
  name: 'ContactPerson',
  components: { Card, Input },
  props: {
    contactPersonTitle: {
      type: String,
      default: 'Контактное лицо'
    },
    contact: {
      type: Object,
      default: {}
    },
    view: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localContact: {...this.contact},
      editing: false,
      usePhoneMask: this.$themeData.usePhoneMask,
      rules: {
        text(min = 0, max = 255) {
          return [
            val => {
              if (val.length < min) {
                return `Минимальное количество символов ${min}`;
              }
              if (val.length > max) {
                return `Максимальное количество символов ${max}`;
              }
              return true;
            }
          ];
        }
      },
      validation
    }  
  },
  methods: {
    save() {
      if (
        !this.localContact.userFullName || 
        !this.localContact.userEmail || 
        !this.localContact.userPhone
      ) {
        toast.error('Заполните все обязательные поля');
        return false;
      }
      
      if (!this.$refs.contactForm.isValid) {
        toast.error('Проверьте правильность заполнения формы');
        return false;
      }
      this.$emit('update:contact', this.localContact);
      this.editing = false;
    },
    cancel() {
      this.localContact = {...this.contact};
      this.editing = false;
    }
  },
  watch: {
    contact: {
      handler(newContact) {
        this.localContact = {...newContact};
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (Config.isGuest()) {
      return;
    }
  }
}
</script>
